import { useState } from "react";
import API from "../api/api";
import toast from "react-hot-toast";

export default function DepositSettlement() {
  const [id, setId] = useState("");

  const settle = async () => {
    try {
      await API.patch(`/deposit-settlement/${id}`);
      toast.success("Waarborg afgerekend");
    } catch {
      toast.error("Waarborg afrekenen mislukt");
    }
  };

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Waarborg afrekenen</h1>
          <p className="page-subtitle">Reken de waarborg af na controle van schade en terugbetaling.</p>
        </div>
      </header>

      <div className="panel panel-pad action-card">
        <div className="form-grid">
          <input
            className="input"
            placeholder="Reservatie ID"
            onChange={(e) => setId(e.target.value)}
          />

          <button className="button" onClick={settle}>
            Waarborg afrekenen
          </button>
        </div>
      </div>
    </section>
  );
}
